import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ClareHomeRPCMethodNames, ClareHomeRPCServiceNames, EVENT_HISTORY_QUERY_METHODS } from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy";

@Injectable({
    providedIn: "root",
})
export class EquatorEventHistoryService {
    constructor(readonly equatorProxyService: EquatorProxyService) {}

    // There will be one of these in each equator-*.service class.
    // It supplies the JSON-RPC service name to the proxy.
    // Use this method in each method below.
    private call(uuid: string, method: ClareHomeRPCMethodNames, params: any[]) {
        return this.equatorProxyService.makeClareHomeRpcRequest$(
            uuid, // uuid
            ClareHomeRPCServiceNames.CLARE_HOME, // service
            method, // method
            params // params
        );
    }

    public getSecurityEvents(uuid: string, startTime: string, endTime: string, limit: number = 100, offset: number = 0): Observable<any> {
        return this.call(uuid, EVENT_HISTORY_QUERY_METHODS.GET_SECURITY_EVENTS, [+startTime, +endTime, limit, offset]);
    }

    public getSecurityServiceEvents(
        uuid: string,
        startTime: string,
        endTime: string,
        limit: number = 100,
        offset: number = 0
    ): Observable<any> {
        return this.call(uuid, EVENT_HISTORY_QUERY_METHODS.GET_SECURITY_SERVICE_EVENTS, [+startTime, +endTime, limit, offset]);
    }
}
